var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveWidgetBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 342.151,
    height: 269.93,
    viewBox: "0 0 342.151 269.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 257.778,
    height: 150,
    fill: "#f07900"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Intro_2",
    "data-name": "Intro 2",
    transform: "translate(-23.848 -263.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M253.3,107.766c-64.4,2.839-76.151-42.582-144.044-30.585S34.392,202.987,82.219,246.655s27.237,51.354,85.055,85.428,155.468-2.729,197.9-64.834,31.12-124.655,6.111-147.652S317.695,104.927,253.3,107.766Z",
    transform: "translate(-27.553 188.036)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525",
    transform: "translate(66 319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M216.09,57.292s-10.31-.648-16.87,2.253l-17.443,10.3c-1.077.674-4.952,5.081-6.327,7.059,0,0-5.677,11.779-7.161,16.177-1.975,5.853-2.491,10.181.683,12.452,5.431,3.886,10.949.127,16.492-7.031,11.789-15.224,18.921-16.266,19.343-16.362l1.163-.263,46.871,48.105h0c3.928-1.448,16.225-6.581,20.028-15.273a35.941,35.941,0,0,1,6.8-10.443L252.119,53.059c-12.073,4.66-22.771,4.308-36.029,4.233",
    transform: "translate(-62.512 -19.897)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M370.29,80.894,331.035,7.935a2.141,2.141,0,0,0-2.9-.87l-26.3,14.153a2.141,2.141,0,0,0-.871,2.9l39.257,72.958a2.14,2.14,0,0,0,2.9.869l26.3-14.152a2.141,2.141,0,0,0,.87-2.9",
    transform: "translate(-112.767 -2.554)",
    fill: "#746f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M107.419,134.117a6.7,6.7,0,0,0-4.213-1.489,6.933,6.933,0,0,0-.934.064,6.7,6.7,0,0,0-4.577,2.75L87.479,149.621a6.768,6.768,0,1,0,10.983,7.913l10.216-14.178a6.766,6.766,0,0,0-1.259-9.239",
    transform: "translate(-32.325 -49.735)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M171.32,181.413a6.707,6.707,0,0,0-4.214-1.489,6.919,6.919,0,0,0-.933.064,6.7,6.7,0,0,0-4.578,2.75L151.8,196.326a6.768,6.768,0,0,0,10.984,7.912l9.79-13.586a6.766,6.766,0,0,0-1.258-9.239",
    transform: "translate(-56.447 -67.471)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M151.646,162.036a6.7,6.7,0,0,0-4.213-1.489,6.931,6.931,0,0,0-.934.064,6.7,6.7,0,0,0-4.578,2.75L130.363,179.4a6.769,6.769,0,1,0,10.983,7.914L152.9,171.275a6.766,6.766,0,0,0-1.259-9.239",
    transform: "translate(-48.407 -60.205)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M132.406,141.7a6.767,6.767,0,0,0-9.724,1.325l-13.761,19.1a6.768,6.768,0,1,0,10.983,7.914l13.761-19.1a6.764,6.764,0,0,0-1.259-9.238",
    transform: "translate(-40.366 -52.578)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M57.393,91.677c-4.228-2.728-8.929-5.5-12.428-7.472L71.052,35.721c15.968,3.339,27.879.847,34.724.737a80.365,80.365,0,0,1,8.389.2l14.643,2.814,5.3-3.318-18.913-3.634a106.656,106.656,0,0,0-12.71-.34C96.27,32.5,86.73,34.723,73.1,31.908l4.483-8.331a6.41,6.41,0,0,0-2.6-8.663L48.681.762a6.4,6.4,0,0,0-8.662,2.6L.762,76.322a6.408,6.408,0,0,0,2.6,8.662l26.3,14.153a6.336,6.336,0,0,0,3.013.764,6.446,6.446,0,0,0,1.856-.276,6.35,6.35,0,0,0,3.794-3.09l4.617-8.58c3.38,1.906,7.881,4.56,11.954,7.181ZM40.221,84.034,34.58,94.518a2.149,2.149,0,0,1-2.9.871L5.382,81.234a2.149,2.149,0,0,1-.869-2.9L43.769,5.382a2.138,2.138,0,0,1,2.9-.87l26.3,14.152a2.14,2.14,0,0,1,.869,2.9L68.169,32.093Z",
    transform: "translate(0 0)",
    fill: "#f07900"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M256.766,171.788a6.13,6.13,0,0,1-9.56,7.572l-26.614-27.315a2.129,2.129,0,1,0-3.05,2.972l23.7,24.325a6.13,6.13,0,1,1-8.78,8.556l-2.356-2.418,0,0-21.343-21.9a2.129,2.129,0,1,0-3.05,2.972l21.347,21.908a6.13,6.13,0,0,1-4.393,10.4h-.081a6.087,6.087,0,0,1-4.31-1.852l-21.344-21.9a2.129,2.129,0,1,0-3.049,2.972l18.2,18.683c-.417,4.783-5.321,6.841-10.215,4.13-5.176-2.866-11.419-8.541-18.668-14.869l-2.5,3.472a222.145,222.145,0,0,0,17.788,14.4c7.788,5.782,14.946,1.932,17.489-3.209a10.308,10.308,0,0,0,6.552,2.436h.138a10.366,10.366,0,0,0,10.358-9.844,10.359,10.359,0,0,0,14.166-8.794,10.379,10.379,0,0,0,13.665-14.1Z",
    transform: "translate(-67.762 -56.776)",
    fill: "#f07900"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveWidgetBg);
export default __webpack_public_path__ + "static/media/active-widget-bg.a5665a3b81d8e5230610a05655b2b81b.svg";
export { ForwardRef as ReactComponent };